export default __webpack_public_path__ + "static/media/jackpot-modal__button.337dc9af.png";